import { h } from 'preact';
import * as BaseComp from 'components/bolt/footer/footer.js';
import { getGeoFromIPAsync, isUserInEU } from 'utils/clientUtils';

export default class Footer extends BaseComp.default {
	async componentDidMount() {
		super.componentDidMount();
		const geo = await getGeoFromIPAsync();
		this.setState({ userCountry: geo?.countryCode });
		const userInEU = await isUserInEU();
		this.setState({ userOutsideEU: !userInEU });
	}

	filterOutCookiePolicy(items = {}) {
		let filteredItems = {};
		Object.keys(items).forEach((key) => {
			if (key !== 'cookies') filteredItems[key] = items[key];
		});

		return filteredItems;
	}
	
	renderLinks(items, type) {
		const { userCountry, userOutsideEU } = this.state;

		const filteredItems = (userOutsideEU ? this.filterOutCookiePolicy(items) : items) || {};

		const usingOneTrust = this.props.store?.appData?.options?.oneTrustCookieConsent?.scripts;
		const oneTrustCookieToggleID = Object.keys(filteredItems).find(key => filteredItems[key]?.url?.toLowerCase()?.includes('onetrust.toggleinfodisplay'));

		if (type !== 'link' || !usingOneTrust || !oneTrustCookieToggleID || userCountry !== 'us') {
			return super.renderLinks(filteredItems, type);
		}

		if (filteredItems[oneTrustCookieToggleID]?.copyUS) {
			const itemsDupe = { ...filteredItems };
			const oneTrustCookieToggleUS = { ...filteredItems[oneTrustCookieToggleID] };
			oneTrustCookieToggleUS.$copy = oneTrustCookieToggleUS.copyUS;
			itemsDupe[oneTrustCookieToggleID] = oneTrustCookieToggleUS;

			return super.renderLinks(itemsDupe, type);
		}

		return super.renderLinks(filteredItems, type);
	}
}